import axios from 'axios';
import Vue from 'vue';
import config from '@config';
import store from '../store';
import { Toast } from 'vant';
import { geturlParams } from '../utils/index.js';

Vue.use(Toast);

const instance = axios.create({
  // 前端超时时间
  timeout: 1000 * 30,

  // 表示跨域请求时是否需要使用凭证
  // withCredentials: true,

  // 默认是 ajax 异步请求
  headers: {
    // auth: ''
    // 'X-Requested-With': 'XMLHttpRequest',
    // 'Accept-Encoding': 'gzip, deflate',
  },

  // baseURL: `${config.apiHost}`,
  // baseURL: `${host}/api`,
  // timeout: 600000,
  // xsrfCookieName: 'ctoken',
  // xsrfHeaderName: 'x-csrf-token',
});

// 配置请求拦截器，支持请求参数isCustomProcessing，表示自定义响应处理
instance.interceptors.request.use(req => {
  // 请求参数存在isCustomProcessing时的处理
  if (window.sessionStorage.getItem('dingdingAuth')) {
    req.headers.token = window.sessionStorage.getItem('dingdingAuth');
  }
  if (process.env.VUE_APP_RUN_ENV === 'dev') {
    // req.headers.token = 'aa-bb-dd,828,dingding';
    req.headers.token =
      '0336c95879f343b384e39171ebb2b0fcae0497db96ba46768064d22ac54f8312cde0e0ac015d4c3897626831e3762547,1557453559,dingding';
  }
  const params = geturlParams();
  if (params['Api-Version']) {
    req.headers.token = params.token;
    req.headers['Api-Version'] = params['Api-Version'];
  }
  if (process.env.VUE_APP_RUN_ENV === 'dev') req.headers.token = 'd0d9438b31294aa8a6f1c07e61e7d45674c5ef929aec49928ce0965c4ed85a4016eeec8dc2a7452e8425f67279aee210,1489995447,dingding';
  if ((req.params && req.params.isCustomProcessing) || (req.data && req.data.isCustomProcessing)) {
    // isCustomProcessing参数用完删除，不要传递给后端
    if (req.params && req.params.isCustomProcessing) {
      delete req.params.isCustomProcessing;
    }
    if (req.data && req.data.isCustomProcessing) {
      delete req.data.isCustomProcessing;
    }

    // 把对isCustomProcessing的处理方法加到transformResponse里去
    if (Array.isArray(req.transformResponse)) {
      req.transformResponse = req.transformResponse.concat([
        result => {
          if (result) {
            result.isCustomProcessing = true;
          }
          return result;
        },
      ]);
    }
  }
  // 统一处理参数
  if (req.data) {
    for (const key in req.data) {
      if (!req.data[key] && req.data[key] !== 0 && req.data[key] !== false) delete req.data[key];
    }
  }
  return req;
});

// 配置接口响应拦截器
instance.interceptors.response.use(
  async response => {
    // 响应结
    const result = response.data || {};
    // 后端未持久化登陆 持中操作
    if (result.msgCode == '401') {
      await store.dispatch('dingdingLogin');
      return Promise.reject({ ...result });
    }

    // 是否使用自定义处理，可在请求参数里设置
    if (result.isCustomProcessing) {
      return result;
    }

    // 请求配置
    // const config = response.config || {};

    // 是否异常
    let isException = false;

    // 是否采用默认异常处理
    let isDefaultExceptionProcess = true;

    // 取消默认异常处理
    const cancelDefaultExceptionPrecess = () => {
      isDefaultExceptionProcess = false;
    };
    // console.log('result:',result)
    // 根据新老接口一般规则判断是否异常，不符合这个规则的可以在请求的时候添加isCustomProcessing:true参数，自行处理返回结果
    if (
      (result.msgCode !== undefined && result.msgCode != '200') ||
      (result.code != '0' && result.message !== undefined)
    ) {
      isException = true;
    }
    if (result.code === '1') {
      return result;
    }

    // 滞后执行，可通过调用cancelDefaultExceptionPrecess方法拦截
    setTimeout(() => {
      if (!isDefaultExceptionProcess) return;

      // 新老接口异常判断
      if (isException) {
        // ...
      }
    }, 0);

    if (isException) {
      // 如果异常，则返回完整的响应信息，并提供撤销默认异常处理的方法，可允许业务端自行处理异常
      /* eslint-disable */
      return Promise.reject({ ...result, cancelDefaultExceptionPrecess });
    } else {
      return result.data;
    }
  },
  error => {
    error = { ...error };

    setTimeout(() => {
      if (error.response.status === 429) {
        Toast.fail({
          duration: 5000,
          message: '当前操作频次超过钉钉接口限制 请重试',
        });
      } else {
        setTimeout(() => {
          Toast.fail('系统错误 请稍后再试');
        });
      }
    });

    // 请求配置信息
    const response = error.response || {};

    // 是否采用默认异常处理
    let isDefaultExceptionProcess = true;
    const cancelDefaultExceptionPrecess = () => {
      isDefaultExceptionProcess = false;
    };

    // 滞后执行，可通过调用cancelDefaultExceptionPrecess方法拦截
    setTimeout(() => {
      if (isDefaultExceptionProcess) {
        // ...
      }
    }, 0);

    return Promise.reject({ ...error, cancelDefaultExceptionPrecess });
  }
);

export default instance;
